import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmptyLayoutComponent } from './empty-layout/empty-layout.component';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'checkout',
    component: EmptyLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: 'app/checkout/checkout.module#CheckoutModule'
      },
    ]
  },
  {
    path: 'certificacion-bac',
    component: EmptyLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: 'app/cert/bac-cert.module#BacCertModule'
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /app/frontend/src/app/app.routing.ts